// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"47524c05","614":"47524c05","881":"47524c05","965":"47524c05"}[chunkId] + ".chunk.css";
};